export const callFunctionConstants = {
    CALL: 'CALL',
    CLEAR_FUNCTION: 'CLEAR_FUNCTION'
};
